/* eslint-disable i18next/no-literal-string */
import { useApiLogisticsV1ShipmentsList } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

type ShipmentChoice = {
  id: number;
  name: string;
};

export type ShipmentAutocompleteProps = Omit<AutocompleteFieldProps<ShipmentChoice>, 'options' | 'defaultValue'> & {
  defaultValue?: ShipmentChoice['id'];
};

export const ShipmentAutocomplete = ({ defaultValue, ...props }: ShipmentAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useApiLogisticsV1ShipmentsList({
    search: query,
  });

  return (
    <AutocompleteField<ShipmentChoice>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(item) => item.name || `Shipment #${item.id}`}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      data-testid="shipment-autocomplete"
      {...props}
    />
  );
};
